import React from 'react';
import { ContentCardProps } from '@/components/card/types';
import { Link } from '@/components/link/Link';
import Icon from '@/components/icon/Icon';
import SerializeDescription from '@/components/serialize-description/SerializeDescription';
import { renameDomProps } from '@/utils/sanitizeDomProps';

const ContentCard: React.FC<ContentCardProps> = React.memo(
  ({ icon, title, description, link, className, ...rest }) => {
    const renamedProps = renameDomProps(rest);

    return (
      <div
        data-component-sub-id={''}
        className={`content-card flex h-full flex-col gap-4 rounded-xl border border-stone-200 bg-white p-6 text-brand-700 ${className} `}
        {...renamedProps}
      >
        {icon?.name && <Icon {...icon} />}
        <h3 className="text-xl font-medium">{title}</h3>
        <div className="text-base">
          {description && <SerializeDescription description={description} />}
        </div>
        {link && <Link {...link}>{link.title}</Link>}
      </div>
    );
  },
);

ContentCard.displayName = 'ContentCard';

export default ContentCard;
